import { Entity, Scheduler } from "@dinahmoe/dmafjs-core";

class EventMapper extends Entity {
  namespace = "control:eventMapper";

  init(node) {
    // TODO will require refactoring to support duýnamic values in event maps, please see scaler

    node.scheduler = new Scheduler(this, this.send.bind(this));
    node.lastEventIn = "";
    node.lastEventOut = "";
  }

  execute(node, config, event) {
    // change in v20, untested
    node.props = config;

    node.maps = node.props.maps;

    if (
      node.props.doDispatch === "ON_CHANGE_IN" &&
      event.name === node.lastEventIn
    ) {
      this.log(
        "ON_CHANGE_IN: lastEventIn is the same: ",
        event.name,
        "ignoring"
      );
      return;
    }

    node.lastEventIn = event.name;

    if (node.props.clearPending) {
      node.scheduler.clear();
    }

    this.log("checking maps against", event.name);
    node.props.maps.forEach(checkMap.bind(this));

    function checkMap(map) {
      // all maps where the in property is not defined are considered a match
      let match;
      if (map.in && map.in.length > 0) {
        match = map.in.some((pattern) => event.name.includes(pattern));
      } else {
        match = true;
      }

      if (match) {
        const event_time = event.time + map.delay;
        if (
          node.props.doDispatch === "ON_CHANGE_OUT" &&
          node.lastEventOut === map.out
        ) {
          this.log(
            "ON_CHANGE_OUT: lastEventOut was the same: ",
            map.out,
            "ignoring"
          );
          return;
        }

        node.scheduler.schedule(event_time, node, {
          name: map.out,
          time: event_time,
          data: { ...event.data, ...map.data },
        });
      }
    }
  }

  send(node, event) {
    this.log("dispatching", event.name, event.time);
    this.dispatch(event.name, event.time, event.data);
    node.lastEventOut = event.name;
  }

  clear(node) {
    node.scheduler.clear();
  }
}

const eventMapper = new EventMapper();
export { eventMapper, EventMapper };
